import { z } from "zod";

/** Relatório de separação: pedidos selecionados (ids por vírgula); sem eles, os primeiros da fila. */
export const pickingSearch = z.object({
  ids: z
    .string()
    .regex(/^[0-9A-Z,]{1,6000}$/)
    .optional()
    .catch(undefined),
});
export type PickingSearch = z.output<typeof pickingSearch>;
